import React, { Component } from 'react';

import SlashCommand from './SlashCommand';

export default class SlashCommands extends Component {
  render() {
    return (
      <ul
        className="list ba br2 dib tl ph4 pv3 pv4-ns mh4 f6 f5-ns"
        style={{
          backgroundColor: '#ebf1f8',
          borderColor: '#a7b6c5',
          lineHeight: '2',
        }}
      >
        <li><SlashCommand /> to display the latest status</li>
        <li>
          <SlashCommand suffix=" [status text]" /> to save
          a new status
        </li>
        <li>
          <SlashCommand suffix=" dashboard" /> gives you a magic link to log in to
          SOTU
        </li>
        <li>
          <SlashCommand suffix=" help" /> for a full list of
          {' '}<SlashCommand /> commands
        </li>
        <li>
          <SlashCommand suffix=" all" /> display the latest status from all
          channels
        </li>
      </ul>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SlashCommands.jsx
 **/